/**
 * read 系 API の path に閲覧ブランチを付与する。viewBranch が null (= 自分のブランチ) の
 * ときは何も付けず、サーバー側のデフォルト (ログインユーザー自身のブランチ) に委ねる。
 */
export const withBranch = (path: string, viewBranch: string | null): string => {
  if (viewBranch === null) return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}branch=${encodeURIComponent(viewBranch)}`;
};

/** `translations/<slug>` から表示用の slug を取り出す。 */
export const branchSlug = (branch: string): string => branch.replace(/^translations\//, '');
